import axios from 'axios';

const BRAVEUP_API_HOST = process.env.REACT_APP_SCHOOLS_API_HOST;

export const BraveBupAPI = axios.create({
  baseURL: `${BRAVEUP_API_HOST}`
});

// export const axiosSetHeaderToken = async (token) => {
//   BraveBupAPI.interceptors.request.use((config) => {
//     config.headers.authorization = `Bearer ${token}`;
//     return config;
//   }, (error) => {
//     return Promise.reject(error);
//   });
// }